import axios from "axios";
import store from "../store";

/**
 * Like src/api/liveOrders.js, baseURL is resolved per call rather than at module scope.
 * store.js registers the menuAlerts Vuex module, which imports this file, so at import
 * time store.js has not finished evaluating and `store` is still undefined. Reading the
 * getter lazily sidesteps the cycle.
 */
const baseURL = () => store.getters.mainAppURL + "realtime/menu_availability/";

const getMenuAvailabilityNotifications = (params) => axios.get(baseURL() + "notifications", {params});

export {
    getMenuAvailabilityNotifications
}
